import type { AnalyticsAttributes } from '@atlassian/jira-product-analytics-bridge';
import { getAnalyticsWebClientPromise } from '@atlassian/jira-product-analytics-web-client-async';
import { EntryKeys } from '../../constants.tsx';
import type { FeedbackEntries, FeedbackRequest } from './types.tsx';

const allowedAttributes = [
	'feedback-collector-id',
	'reason',
	'feeling',
	EntryKeys.IS_ATLASKIT_FEEDBACK_COMPONENT,
];

const getAnalyticsPayloadFromAdditionalEntries = (
	additionalFeedbackEntries: FeedbackEntries,
): AnalyticsAttributes => {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const payload: Record<string, any> = {};

	additionalFeedbackEntries.forEach((entry) => {
		if (allowedAttributes.includes(entry.key)) {
			payload[entry.key] = entry.value || 'empty';
		}
	});

	return payload;
};

export const fireFeedbackCreatedAnalytics = async (
	entrypointId: string | undefined,
	request: FeedbackRequest,
) => {
	const fullAnalyticsId = 'jira-jsd-widget-feedback.feedback';
	const { additionalFeedbackEntries } = request;

	const gasV3Event = {
		action: 'created',
		actionSubject: fullAnalyticsId,
		// Note: the `source` is not related to JSD project. The `source` is used wrongly here.
		// Since it's minor and we don't break reports used by other teams, so we accept this.
		source: 'jira-jsd-widget-feedback',
		attributes: {
			...getAnalyticsPayloadFromAdditionalEntries(additionalFeedbackEntries),
			entrypointId,
		},
	};
	const analyticsClient = await getAnalyticsWebClientPromise();
	analyticsClient.getInstance().sendOperationalEvent(gasV3Event);
};
